import $ from "jquery";
import swal from "sweetalert";
import Choices from "choices.js";
var feather = require('feather-icons');
var symfonyCollection = {
    init: function () {
    },
    add: function (collectionHolder, button, callback) {
        var callback = callback || function () { };
        var prototype = collectionHolder.attr("data-prototype-" + button.data("type"));
        var newForm = prototype.replace(/__name__/g, collectionHolder.children().length);
        var $newFormDiv = $('<div class="collection-item"></div>').append(newForm);
        collectionHolder.append($newFormDiv);
        symfonyCollection.remove($newFormDiv.children());
        callback.call(this, $newFormDiv.children());
        collectionHolder.find('.Task').each(function (i, v) {
            var position = i + 1;
            $(v).find('.nb-task').html(position);
            $(v).find("input[id$='position']").val(position);
        });
    },
    remove: function ($tagFormElm) {
        var button = document.createElement("a");
        var icon = document.createElement("span");
        $(icon)
            .attr("data-feather", "delete");
        $(button)
            .attr("href", "#remove")
            .addClass("Button has-icon icon-only go-primary no-rounded")
            .append(icon);
        $tagFormElm.prepend(button);
        $(button).on('click', function (e) {
            e.preventDefault();
            swal({
                title: " ",
                text: $(".Task").data("message"),
                icon: "warning",
                buttons: [$(".Task").data("cancel"), $(".Task").data("confirm")],
                dangerMode: true
            })
                .then(function (willDelete) {
                if (willDelete) {
                    $tagFormElm.fadeOut(200, function () {
                        $tagFormElm.remove();
                        $('.Task').each(function (i, v) {
                            $(this).find('.nb-task').html(i + 1);
                        });
                    });
                }
            });
            // swal({
            // 	title: " ",
            // 	text: $(".Task").data("message"),
            // 	type: "warning",
            // 	cancelButtonText: $(".Task").data("cancel"),
            // 	showCancelButton: true,
            // 	confirmButtonColor: "#DD6B55",
            // 	confirmButtonText: $(".Task").data("confirm"),
            // 	closeOnConfirm: true,
            // 	animation: "slide-from-top"
            // },
            // function(){
            // 	$tagFormElm.fadeOut(200,function(){
            // 		$tagFormElm.remove();
            // 		$('.Task').each(function(i,v) {
            // 			$(this).find('.nb-task').html(i + 1);
            // 		});
            // 	});
            // });
        });
    }
};
function manageTasks() {
    /*
     * Logic starts here
    **/
    var collectionHolder = $('.tasks');
    var tasksHolder = $('.TasksHolder');
    var $submitElement = $('.submit');
    var $addtaskLink = $('<div class="add-task"></div>');
    var linkElement = document.createElement("a");
    var labelElement = document.createElement("span");
    $(labelElement)
        .addClass("label")
        .html(tasksHolder.children(".tasks").data("label-add"));
    $(linkElement)
        .attr("href", "#add-task")
        .addClass("add_task_link Button no-rounded revert small has-icon")
        .data("type", "task")
        .append(labelElement);
    $addtaskLink.append(linkElement);
    tasksHolder.append($addtaskLink);
    tasksHolder.children(".tasks").find('div.Task').each(function () {
        symfonyCollection.remove($(this));
    });
    $("body").on('click', "a.add_task_link", function (e) {
        e.preventDefault();
        symfonyCollection.add($('.TasksHolder').children(".tasks"), $(this), function (item) {
            $('select:not(.choices__input)').each(function (k, v) {
                var select = new Choices(v, {
                    removeItemButton: false
                });
                if ($(v).hasClass("select-type")) {
                    $(v).on("change", function () {
                        var task = $(v).parents(".Task");
                        var qty = task.find(".qty");
                        var commission = task.find(".commission");
                        var type = task.find(".type").find("select").val();
                        switch (type) {
                            case "production":
                                qty.addClass("hidden");
                                commission.removeClass("hidden");
                                if (qty.find("input").val() == "") {
                                    qty.find("input").val(1);
                                }
                                break;
                            default:
                                commission.addClass("hidden");
                                qty.removeClass("hidden");
                                if (commission.find("input").val() == "") {
                                    commission.find("input").val(0);
                                }
                                break;
                        }
                    });
                }
            });
            feather.replace();
        });
    });
}
$(document).ready(function () {
    if ($('form[name="document_form"]').length) {
        manageTasks.call();
    }
});
